import itemGroupsService from "../../../../../services/items/categories/itemGroups/itemGroups.service";
import { itemGroupsActionTypes } from "../../../../actionTypes/items/categories/itemGroups/itemGroups.actionTypes";

// Get Item Groups (Paginated)
export const getItemGroups = (queryParams) => async (dispatch) => {
  try {
    dispatch({ type: itemGroupsActionTypes.START_GET_ITEM_GROUPS });
    const response = await itemGroupsService.getItemGroups(queryParams);
    dispatch({
      type: itemGroupsActionTypes.GET_ITEM_GROUPS_SUCCESS,
      data: response.data.payload,
    });
    return response.data; // Return server response
  } catch (ex) {
    console.error("Get item groups error:", ex.message);
    dispatch({
      type: itemGroupsActionTypes.GET_ITEM_GROUPS_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data; // Return error
  }
};

// Connect Item Group with Category
export const connectItemGroupWithCategory = (categoryId, itemGroupId) => async (dispatch) => {
  try {
    dispatch({ type: itemGroupsActionTypes.START_CONNECT_ITEM_GROUP_WITH_CATEGORY });
    const response = await itemGroupsService.connectItemGroupWithCategory(categoryId, itemGroupId);
    dispatch({
      type: itemGroupsActionTypes.CONNECT_ITEM_GROUP_WITH_CATEGORY_SUCCESS,
    });
    return response.data;
  } catch (ex) {
    console.error("Connect item group with category error:", ex.message);
    dispatch({
      type: itemGroupsActionTypes.CONNECT_ITEM_GROUP_WITH_CATEGORY_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data;
  }
};

export const updateDisplayOrder = (categoryId, itemGroupId) => async (dispatch) => {
  try {
    dispatch({ type: itemGroupsActionTypes.START_UPDATE_DISPLAY_ORDER });
    const response = await itemGroupsService.updateDisplayOrder(categoryId, itemGroupId);
    dispatch({
      type: itemGroupsActionTypes.UPDATE_DISPLAY_ORDER_SUCCESS,
    });
    return response.data;
  } catch (ex) {
    console.error("Connect item group with category error:", ex.message);
    dispatch({
      type: itemGroupsActionTypes.UPDATE_DISPLAY_ORDER_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data;
  }
};

// Disconnect Item Group from Category
export const disconnectItemGroupFromCategory = (categoryId, itemGroupId) => async (dispatch) => {
  try {
    dispatch({ type: itemGroupsActionTypes.START_DISCONNECT_ITEM_GROUP_FROM_CATEGORY });
    const response = await itemGroupsService.disconnectItemGroupFromCategory(categoryId, itemGroupId);
    dispatch({
      type: itemGroupsActionTypes.DISCONNECT_ITEM_GROUP_FROM_CATEGORY_SUCCESS,
    });
    return response.data;
  } catch (ex) {
    console.error("Disconnect item group from category error:", ex.message);
    dispatch({
      type: itemGroupsActionTypes.DISCONNECT_ITEM_GROUP_FROM_CATEGORY_FAILURE,
      error: ex.response?.data,
    });
    throw ex.response?.data;
  }
};

export const updateItemGroupsLocally = (updatedItemGroups) => ({
  type: itemGroupsActionTypes.UPDATE_ITEM_GROUPS_LOCALLY,
  data: updatedItemGroups,
});

const itemGroupsActions = {
  getItemGroups,
  connectItemGroupWithCategory,
  disconnectItemGroupFromCategory,
  updateDisplayOrder,
  updateItemGroupsLocally
};

export default itemGroupsActions;
